export default {

  todaysEodReviewPreview(state, data) {
    state.todaysEodReviewPreview = data;
  },
  todaysJournal(state, data) {
    state.todaysJournal = data;
  },
  
};
